import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles'
import { MenuOutlined } from '@material-ui/icons'
import { connect } from 'react-redux'
import { AppBar as UIAppBar, Toolbar, IconButton, Box } from '@material-ui/core'

import { DRAWER_WIDTH } from './../../class/constants'
import { Label } from '../default'

function AppBar({
  classes, onMenuClick,

  customerInfo
}) {
  return (
    <UIAppBar position='fixed' className={classes.appBar}>
      <Toolbar variant='dense'>
        <div className={classes.tbMain}>
          <div className={classes.tbLeft}>
            <IconButton edge='start' onClick={onMenuClick} className={classes.menuButton}>
              <MenuOutlined />
            </IconButton>

            <Box display={{ xs: 'none', sm: 'block' }}>
              <Label bold>
                {
                  customerInfo && customerInfo.customerCompany ? (
                    customerInfo.customerCompany.name
                  ) : null
                }
              </Label>
            </Box>
          </div>
        </div>
      </Toolbar>
    </UIAppBar>
  )
}

const mapStateToProps = state => ({
  customerInfo: state.ReducerCustomer.customerInfo
})

AppBar.propTypes = {
  onMenuClick: PropTypes.func
}

AppBar.defaultProps = {
  onMenuClick: () => true
}

const styles = theme => ({
  appBar: {
    position: 'fixed',
    marginLeft: DRAWER_WIDTH,

    [theme.breakpoints.up('md')]: {
      //display: 'none',
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
    },
    background: theme.palette.background.shade01,
    color: theme.palette.textColor.main
  },
  tbMain: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    aliginItems: 'center',
    height: '50px',
  },
  tbLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  menuButton: {
    color: theme.palette.textColor.main,
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    }
  }
})

export default connect(mapStateToProps)(withStyles(styles)(AppBar))
